import React from 'react';
import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import Modal from '@/components/ui/Modal/Modal';
import { queryClient } from '@/utils/ReactQuery';
import SubmitFooter from '@/components/ui/Modal/SubmitFooter';
import { plato_api_glossary_terms_path } from '@/modules/routes';
import { useTableGlossaryTerms } from '@/components/admin/GlossaryTermsTable/GlossaryTermTable.utils';
import GlossaryTermForm from './GlossaryTermForm';

interface GlossaryModalProps {
  isOpen: boolean,
  handleClose: () => void,
}

const AddGlossaryTerm = ({ isOpen, handleClose }: GlossaryModalProps) => {
  const path = window.location.pathname.split('/');
  const section = path[2] || '';
  const sectionId = path[3];

  const { queryKey } = useTableGlossaryTerms({ sectionId });

  const { isLoading, mutate } = useMutation({
    mutationFn: (formData: FormData) => axios.post(plato_api_glossary_terms_path(), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
    onError: (e) => {
      console.log(e);
    },
    onSettled: handleClose,
    onSuccess: () => {
      queryClient.invalidateQueries(['glossaryTerms']);
      queryClient.invalidateQueries(queryKey);
    },
  });

  return (
    <>
      <Modal
        className="tw-h-fit tw-w-[800px]"
        close={handleClose}
        headerText="Create Glossary Term"
        isOpen={isOpen}
      >
        <GlossaryTermForm sectionId={sectionId || section} onSubmit={mutate}>
          <SubmitFooter isValid close={handleClose} isLoading={isLoading} />
        </GlossaryTermForm>
      </Modal>
    </>
  );
};

export default AddGlossaryTerm;
